<div class="banner d-lg-flex d-none">
  <h1 class="font-heading fw-bold text-uppercase">{{ 'marketplace.page.title' | translate }}</h1>
</div>

<div class="d-lg-none">
  <fgb-barcode></fgb-barcode>
</div>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container">
  <fgbcl-marketplace-list
    [isList]="true"
    [marketplaceItemView]="true"
    [marketplaceItemTypes]="[0, 1, 2]"
    [defaultSort]="0"
  ></fgbcl-marketplace-list>
</div>
